import { useLocalSearchParams } from 'expo-router'
import { useLoggedInInviteAcceptance } from '@/hooks/useLoggedInInviteAcceptance'
import {
    ErrorState,
    InvalidInviteState,
    LoadingState,
    WrongRecipientState,
} from '@/ui/auth/AcceptInviteStates'
import { InviteSignupForm } from '@/ui/auth/InviteSignupForm'

export default function AcceptInvitationPage() {
    const params = useLocalSearchParams<{ inviteId: string }>()
    const inviteId = params.inviteId

    const {
        isLoggedIn,
        isLoading: isAcceptingInvite,
        error: acceptError,
        isWrongRecipient,
        showSignupOption,
        hideSignupForm,
        logoutAndRefresh,
        invitedEmail,
    } = useLoggedInInviteAcceptance(inviteId || '')

    if (!inviteId) {
        return <InvalidInviteState />
    }

    if (isLoggedIn && isAcceptingInvite && !isWrongRecipient) {
        return <LoadingState message="Accepting invitation..." />
    }

    if (isLoggedIn && isWrongRecipient && !showSignupOption) {
        return (
            <WrongRecipientState
                invitedEmail={invitedEmail}
                onSignUpWithInvitedEmail={logoutAndRefresh}
            />
        )
    }

    if (isLoggedIn && acceptError && !isWrongRecipient) {
        return <ErrorState error={acceptError} />
    }

    return (
        <InviteSignupForm
            inviteId={inviteId}
            showBackButton={showSignupOption}
            onBack={hideSignupForm}
            title="Accept Invitation"
            subtitle={
                showSignupOption
                    ? 'Create a new account to accept this invitation'
                    : 'Create your account to join the organization'
            }
        />
    )
}
